import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { createConversationMessage } from 'api/ai-assistant/ai-assistant-api';
import type { StreamFetchResult } from 'api/api.config';

interface UseApiCreateConversationMessageArgs {
  oktaUserId: string;
  clientId: string | number;
}

interface CreateMessageVariables {
  conversationId: string;
  data: unknown;
  onChunk?: (chunk: unknown) => void;
}

export const useApiCreateConversationMessage = ({
  oktaUserId,
  clientId,
}: UseApiCreateConversationMessageArgs): UseMutationResult<
  StreamFetchResult,
  unknown,
  CreateMessageVariables
> =>
  useMutation<StreamFetchResult, unknown, CreateMessageVariables>({
    mutationFn: ({ conversationId, data, onChunk }) =>
      createConversationMessage({
        oktaUserId,
        conversationId,
        data,
        onChunk,
        clientId,
      }),
  });
